/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ masked: NonNullable<unknown> }} Account_Delivery_Email_Identity_MaskedInputs */

const he_account_delivery_email_identity_masked = /** @type {(inputs: Account_Delivery_Email_Identity_MaskedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.masked}`)
};

const en_account_delivery_email_identity_masked = /** @type {(inputs: Account_Delivery_Email_Identity_MaskedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.masked}`)
};

/**
* | output |
* | --- |
* | "{masked}" |
*
* @param {Account_Delivery_Email_Identity_MaskedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_email_identity_masked = /** @type {((inputs: Account_Delivery_Email_Identity_MaskedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Email_Identity_MaskedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_email_identity_masked(inputs)
	return en_account_delivery_email_identity_masked(inputs)
});